export default __webpack_public_path__ + "static/media/fungal-tinea-Infectionp.1c464a0b.pdf";